'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "mw-keybindings/DefaultKeys",
    "mw-filename-utils/FileNameUtil",
    "dojo/i18n!nls/mldoStringResource"
], function (declare, Action, DefaultKeys, FileNameUtil, MLDOStrings) {
    return declare(Action, {
        constructor: function (args) {
            args = args || {};
            let context = args.context;
            let makeActionAvailable = args.showAction || false;
            this.name =  "openInMatlabDesktopAction";
            this.label = MLDOStrings.contextMenuOpenInMDLabel;
            this.id = "mldoOpenInMDAction";
            this.enabled = makeActionAvailable;
            this.section = {
                id: "openSub",
                enabled: false,
                isApplicableTo: function() { return false; },
                label: "sub1",
                parent: {
                    id: "mldoOpenAction",
                    name: MLDOStrings.contextMenuOpenLabel,
                    label: MLDOStrings.contextMenuOpenLabel,
                    allowSubMenu: true,
                    forceSubMenu: true
                }
            };
            this.isApplicableTo = function (path) {
                let selectedFileCount = context.getSelectedRowCount();
                if (selectedFileCount > 1) {
                    this.enabled = false;
                } else {
                    let fileInfos = context.getSelectedItemFileInfos();
                    let fileInfo = fileInfos[0];
                    // Enable action if nothing selected, for folders and applicable files
                    if (!fileInfo || fileInfo.isDirectory || context.canOpenInMatlabOnline(FileNameUtil.getFileNameExtension(fileInfo.name))) {
                        this.enabled = makeActionAvailable && true;
                    } else {
                        this.enabled = false;
                    }
                }
                return this.enabled;
            };
            this.callback = function (action) {
                let fileInfos = context.getSelectedItemFileInfos();
                let fileInfo = fileInfos[0];
                if (!this.isApplicableTo(fileInfo)) return;
                if (context.mockOpenwith()) {
                    return context.displayMockOpenWithAlert(fileInfo);
                }
                let currentFolder = context.getCurrentFolder();
                let path = fileInfo ? FileNameUtil.pathFromFileInfo(fileInfo) : currentFolder;
                if (fileInfo && currentFolder !== "/") {
                    path = currentFolder + path;
                }
                let target = fileInfo || context.getCurrentFolderInfo();
                let invitationDetails = (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function")
                    ? this.getInvitationDetailsMethod() : null;

                if (invitationDetails && typeof invitationDetails === "object") {
                    context.handleOpenInDesktopAction(path, target, invitationDetails.authenticated, invitationDetails.invitationId, invitationDetails.invitationName,
                        invitationDetails.invitationType, invitationDetails.invitationStatus, invitationDetails.invitationFullPath);
                } else {
                    context.handleOpenInDesktopAction(path, target, true);
                }
            };
        }
    });

});
